export default __webpack_public_path__ + "static/media/a012-market-4.e03db339.svg";